export const enum DateRangeOption {
    YearToDate = "yearToDate",
    LastYear = "lastYear",
    Last7Days = "last7Days",
    Last14Days = "last14Days",
    Custom = "custom",
}
